import BigNumber from 'bignumber.js'
import { toToken } from '~/config/constants/tokens'
import { PoolConfig, SerializedPoolConfig } from '~/config/constants/types'
import { SerializedFarm, DeserializedPool, SerializedPool } from '~/state/types'
import { deserializeToken, serializeToken } from '~/state/user/hooks/helpers'
import { BIG_ZERO } from '~/utils/bigNumber'

type UserData =
  | DeserializedPool['userData']
  | {
      allowance: number | string
      stakingTokenBalance: number | string
      stakedBalance: number | string
      pendingReward: number | string
    }

export const transformUserData = (userData: UserData) => {
  return {
    allowance: userData ? new BigNumber(userData.allowance) : BIG_ZERO,
    stakingTokenBalance: userData ? new BigNumber(userData.stakingTokenBalance) : BIG_ZERO,
    stakedBalance: userData ? new BigNumber(userData.stakedBalance) : BIG_ZERO,
    pendingReward: userData ? new BigNumber(userData.pendingReward) : BIG_ZERO,
  }
}

export const transformPool = (pool: SerializedPool): DeserializedPool => {
  const { totalStaked, stakingLimit, userData, stakingToken, earningToken, pendingBurnBatchReward, nextClaimableBurn, ...rest } = pool

  return {
    ...rest,
    stakingToken: deserializeToken(stakingToken),
    earningToken: deserializeToken(earningToken),
    userData: transformUserData(userData),
    totalStaked: new BigNumber(totalStaked),
    stakingLimit: new BigNumber(stakingLimit),
    pendingBurnBatchReward: new BigNumber(pendingBurnBatchReward),
    nextClaimableBurn: new BigNumber(nextClaimableBurn)
  }
}

export const getTokenPricesFromFarm = (farms: SerializedFarm[]) => {
  return farms.reduce((prices, farm) => {
    const quoteTokenAddress = farm.quoteToken.address.toLocaleLowerCase()
    const tokenAddress = farm.token.address.toLocaleLowerCase()
    /* eslint-disable no-param-reassign */
    if (!prices[quoteTokenAddress]) {
      prices[quoteTokenAddress] = new BigNumber(farm.quoteTokenPriceBusd).toNumber()
    }
    if (!prices[tokenAddress]) {
      prices[tokenAddress] = new BigNumber(farm.tokenPriceBusd).toNumber()
    }
    /* eslint-enable no-param-reassign */
    return prices
  }, {})
}


export const toSerializedPoolConfig = (chainId: number , pool: PoolConfig) : SerializedPoolConfig => {
  const serializedFarmConfig = {
      ...pool,
      stakingToken: pool.stakingToken ? serializeToken(toToken(chainId, pool.stakingToken)) : undefined,
      earningToken: pool.earningToken ?  serializeToken(toToken(chainId, pool.earningToken)) : undefined,
    }
  return serializedFarmConfig;
}
